import { createTestIds } from "../../util/createTestIds";

export default createTestIds("package-page", [
  "page",
  "feedbackLinks",
  "reportLink",
  "reportAbuseLink",
  "githubLink",
  "dependenciesTab",
  "dependenciesList",
  "dependenciesLink",
  "badgeTab",
  "description",
  "markdown",
  "selectVersionButton",
  "selectVersionDropdown",
  "selectVersionItem",
] as const);
